// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* control-panel-section */

.ch1-1-control-panel-section{
  
  /* min-width: fit-content; */
  width: calc(100%-4rem);
  min-width: -moz-fit-content;
  min-width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(128, 128, 128, 0.048);
  margin: 10px 2rem;

}
/* Model select area */
.model-select-container{
  margin: 10px 2rem;
}

.model-selected{
  /* border: 1px solid red; */
  box-shadow: inset 0 0 5px rgba(255, 208, 0, 1);
  transform: scale(0.95);
}

/* Network area */

.onclick-prev-neural {
  border: 1px solid red !important;
}

.neural{
  width: 60px;
  height: 60px;
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  box-shadow: 2px 2px 5px black;
}

.neural sub {
  font-size: 0.5em;
}

.layer1N{
  background-color: #FFC700;
}

.layer2N{
  background-color: rgb(36, 0, 255, 0.15);
}
.layer3N{
  background-color: rgb(36, 0, 255, 0.3);
}
.layer4N{
  background-color: rgb(36, 0, 255, 0.45);
}
.layer5N{
  background-color: rgb(36, 0, 255, 0.6);
}


.ch1-1-layer-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ch1-1-layer-container div{
  margin: 2px;
}


.ch1-1-control-input-container{
  display: flex;
  align-items: center;
  justify-content: center;
}


.ch1-1-network-input,
.ch1-1-weight-input,
.ch1-1-bias-input{
  width: 60px;
  border: none;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}


/* Visulization Container */

.ch1-1-visulization-container{
  min-width: calc(100% - 4rem);
  display: flex;


  margin: 10px 2rem;
}

/* Graphic Section */

/* Fomurla Container */
.formula-section{
  width: 100%;
  min-width: 400px;

  margin-left: 2rem;
}


.formula-container {
  width: 100%;
}


.full-question-container{
  display: flex;
  align-items: center;


}`, "",{"version":3,"sources":["webpack://./src/pages/ch2/neural_network_formula.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;;EAEE,4BAA4B;EAC5B,sBAAsB;EACtB,2BAAsB;EAAtB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;;AAEnB;AACA,sBAAsB;AACtB;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA,iBAAiB;;AAEjB;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;;;EAGE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;;AAGA,2BAA2B;;AAE3B;EACE,4BAA4B;EAC5B,aAAa;;;EAGb,iBAAiB;AACnB;;AAEA,oBAAoB;;AAEpB,sBAAsB;AACtB;EACE,WAAW;EACX,gBAAgB;;EAEhB,iBAAiB;AACnB;;;AAGA;EACE,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,mBAAmB;;;AAGrB","sourcesContent":["/* control-panel-section */\n\n.ch1-1-control-panel-section{\n  \n  /* min-width: fit-content; */\n  width: calc(100%-4rem);\n  min-width: fit-content;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(128, 128, 128, 0.048);\n  margin: 10px 2rem;\n\n}\n/* Model select area */\n.model-select-container{\n  margin: 10px 2rem;\n}\n\n.model-selected{\n  /* border: 1px solid red; */\n  box-shadow: inset 0 0 5px rgba(255, 208, 0, 1);\n  transform: scale(0.95);\n}\n\n/* Network area */\n\n.onclick-prev-neural {\n  border: 1px solid red !important;\n}\n\n.neural{\n  width: 60px;\n  height: 60px;\n  font-size: 1.2em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  border-radius: 50%;\n  box-shadow: 2px 2px 5px black;\n}\n\n.neural sub {\n  font-size: 0.5em;\n}\n\n.layer1N{\n  background-color: #FFC700;\n}\n\n.layer2N{\n  background-color: rgb(36, 0, 255, 0.15);\n}\n.layer3N{\n  background-color: rgb(36, 0, 255, 0.3);\n}\n.layer4N{\n  background-color: rgb(36, 0, 255, 0.45);\n}\n.layer5N{\n  background-color: rgb(36, 0, 255, 0.6);\n}\n\n\n.ch1-1-layer-container{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.ch1-1-layer-container div{\n  margin: 2px;\n}\n\n\n.ch1-1-control-input-container{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.ch1-1-network-input,\n.ch1-1-weight-input,\n.ch1-1-bias-input{\n  width: 60px;\n  border: none;\n  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n\n/* Visulization Container */\n\n.ch1-1-visulization-container{\n  min-width: calc(100% - 4rem);\n  display: flex;\n\n\n  margin: 10px 2rem;\n}\n\n/* Graphic Section */\n\n/* Fomurla Container */\n.formula-section{\n  width: 100%;\n  min-width: 400px;\n\n  margin-left: 2rem;\n}\n\n\n.formula-container {\n  width: 100%;\n}\n\n\n.full-question-container{\n  display: flex;\n  align-items: center;\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
